var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer"},[_c('div',{staticClass:"footer__inner"},[_vm._v(_vm._s(_vm.copyright))])])}
var staticRenderFns = []

export { render, staticRenderFns }